<template>
    <div id="app">
        <DataView/>
    </div>
</template>

<script>
import DataView from "@/components/data-view";

export default {
	name: 'App',
	components: {
		DataView
	}
}
</script>

<style>

</style>
